import { useAuth0 } from '@auth0/auth0-react';
import { TableCell } from '@material-ui/core';
import TableRow from '@material-ui/core/TableRow';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import AuthService from "Lib/API/Auth";
import PreSchoolService from 'Lib/API/PreSchool';
import PaidIcon, { ReactComponent as Paidicon } from 'assets/icons/PaidIcon.svg';
import PendingIcon from 'assets/icons/PendingIcon.svg';
import Action from 'components/ActionPopOver';
import { CheckBox } from "components/CheckBox/CheckBox";
import AlertDialog from 'components/Dialog';
import Loader from 'components/loader/Loader';
import { formatDate, numberFormat } from 'helper';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { useHistory } from "react-router-dom";
import SElect from 'react-select';
import { Account, AccountWrapper, Status } from './Theme';
import './index.scss';

const ParticipantDetailsTableBody = ({
  setOpenDrawer,
  setDrawerData,
  rows,
  loading,
  classId,
  refresh,
  setRefresh,
  onSharePaymentLinkClick,
  onCheckboxChange,
  check,
  checkAll
}) => {
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [paymentLinkId, setPaymentLinkId] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [moveParticipantId, setMoveParticipantId] = useState(null);
  const [classMovedId, setClassMovedId] = useState(null);
  const [currentRow, setCurrentRow] = useState(null);
  const className = useSelector((state) => state.education.className);

  const history = useHistory();

  const { getAccessTokenSilently } = useAuth0();

  const getStatusMessage = (newStatus, currentRow) => {
    if (currentRow?.registrationStatus === 'pending' && newStatus === 'approved') {
      return `You are about to admit ${currentRow?.firstName} ${currentRow?.lastName} into  Class ${className}, please confirm`;
    }
    if (currentRow?.registrationStatus === 'pending' && newStatus === 'not-approve') {
      return `You are about to deny ${currentRow?.firstName} ${currentRow?.lastName} into  Class ${className}, please confirm`;
    }
    if (currentRow?.registrationStatus === 'pending' && newStatus === 'on-hold') {
      return '';
    }
    if (currentRow?.registrationStatus === 'approved' && newStatus === 'not-approve') {
      return `You are about to deny ${currentRow?.firstName} ${currentRow?.lastName} from Class ${className}, please confirm`;
    }
    if (currentRow?.registrationStatus === 'not-approve' && newStatus === 'approved') {
      return `You are about to admit ${currentRow?.firstName} ${currentRow?.lastName} into class ${className}, please confirm`;
    }
    return ""
  };

  const getDeleteMessage = (currentRow) => {
    if (currentRow?.registrationStatus === 'pending') {
      return `You are about to delete ${currentRow?.firstName} ${currentRow?.lastName} from Class ${className}, please confirm`;
    }
    if (currentRow?.registrationStatus === 'approved') {
      return `You are about to delete ${currentRow?.firstName} ${currentRow?.lastName} from Class ${className}, please confirm`;
    }
    if (currentRow?.registrationStatus === 'not-approve') {
      return `You are about to delete ${currentRow?.firstName} ${currentRow?.lastName} from Class ${className}, please confirm`;
    }
    if (currentRow?.registrationStatus === 'on-hold') {
      return `You are about to delete ${currentRow?.firstName} ${currentRow?.lastName} from Class ${className}, please confirm`;
    }
    return '';
  }
  const deleteParticipant = async (id) => {
    try {
      setConfirmLoading(true);
      const token = await getAccessTokenSilently();
      const result = await PreSchoolService.deleteParticipantById(token, id);
      toastr.success(
        'Success',
        result?.result?.message || 'Participant deleted successfully'
      );
      setRefresh(!refresh);
    } catch (error) {
      toastr.error('Error', error?.data?.message || 'Something went wrong');
    } finally {
      setDeleteId(null);
      setConfirmDialog(false);
      setConfirmLoading(false);
    }
  };
  const changeStatus = async (status) => {
    const payload = {
      classId,
      participantId: status?.id,
      status: status?.value,
    };
    try {
      setConfirmLoading(true);
      const token = await getAccessTokenSilently();
      const result = await PreSchoolService.changeStatusParticipant(
        token,
        payload
      );
      toastr.success(
        'Success',
        result?.result?.message || 'Participant status updated successfully'
      );
      setRefresh(!refresh);
    } catch (error) {
      toastr.error('Error', error?.data?.message || 'Something went wrong');
    } finally {
      setSelectedStatus(null);
      setConfirmDialog(false);
      setCurrentRow(null);
      setConfirmLoading(false);
    }
  };

  const sendPaymentLink = async (id) => {
    const payload = {
      participantId: id,
    };
    try {
      setConfirmLoading(true);
      const token = await getAccessTokenSilently();
      const result = await PreSchoolService.sendPaymentLink(token, payload);
      toastr.success(
        'Success',
        result?.result?.message || 'Payment link sent successfully'
      );
      setRefresh(!refresh);
    } catch (error) {
      toastr.error('Error', error?.data?.message || 'Something went wrong');
    } finally {
      setPaymentLinkId(null);
      setConfirmDialog(false);
      setConfirmLoading(false);
    }
  };

  const moveParticipantToAnotherClass = async () => {
    const payload = {
      newClass: classMovedId,
      participantId: moveParticipantId,
    };
    try {
      setConfirmLoading(true);
      const token = await getAccessTokenSilently();
      const result = await PreSchoolService.moveParticipant(token, payload);
      toastr.success(
        'Success',
        result?.result?.message || 'Participant moved successfully'
      );
    } catch (error) {
      toastr.error('Error', error?.data?.message || 'Something went wrong');
    } finally {
      setMoveParticipantId(null);
      setClassMovedId(null);
      setConfirmDialog(false);
      setConfirmLoading(false);
      setRefresh(!refresh);
    }
  };

  let options = [
    { label: 'Approved', value: 'approved', icon: <Paidicon /> },
    { label: 'Not Approved', value: 'not-approve' },
    { label: 'On Hold', value: 'on-hold' },
    { label: "Pending", value: "pending" }
  ];

  const formatOptionLabel = ({ value, label, icon }) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {label === 'Approved' && <Paidicon className="mr-1" />}
      <div>{label}</div>
    </div>
  );
  const handleOnClickAccountId = (accountId, contactId) => {
    async function fetchMyAPI() {
      const token = await getAccessTokenSilently();
      AuthService.getContactById(contactId, token)
        .then((res) => {
          if (res) {
            history.push(`/member-details/${accountId}/family-member`, res[0])
          }
        })
        .catch((err) => {
          toastr.error("Error", err?.data?.message);
        });
    }
    fetchMyAPI();
  }

  const totalPaymentCalculation = (approveTotalPaid,registerTotalPaid) => {
    const totalPayment = +approveTotalPaid + +registerTotalPaid;
    return numberFormat({number:totalPayment || 0, decimal:2,style:"currency"}) 
  }



  return (
    <>
      {loading ? (
        <TableRow>
          <TableCell colSpan={8} align="center">
            <div className="user__loader" style={{ height: '320px' }}>
              <Loader />
            </div>
          </TableCell>
        </TableRow>
      ) : rows?.length === 0 ? (
        <TableRow>
          <TableCell colSpan={8} align="center">
            <h6>No Participants Found</h6>
          </TableCell>
        </TableRow>
      ) : (
        rows?.map((row) => (
          <TableRow>
              <TableCell
                align="left"
              >
               <CheckBox
                  onChange={(e) => onCheckboxChange(e, row)}
                  checked={checkAll ? true : check.find((obj) => obj._id === row?._id)}
                  text={""}
                  isDisabled={checkAll}
                />
             </TableCell>
            <TableCell
              align="left"
              onClick={() => {
              }}
            >{row?.account &&
              <AccountWrapper>
                <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  <Account onClick={() => history.push(`/member-details/${row?.account?._id}`)}>{row?.account?.family_name}</Account>
                  {row?.account?._id && (
                    <a
                      href={`/member-details/${row?.account?._id}`}
                      target="_blank"
                      rel="noreferrer"
                      onClick={(e) => e.stopPropagation()}
                      style={{ display: "flex", alignItems: "center", color: "#2555EF", flexShrink: 0 }}
                    >
                      <OpenInNewOutlinedIcon style={{ fontSize: 10, width: 18, height: 18 }} />
                    </a>
                  )}
                </div>
                {row?.account?.account_id && <Account onClick={() => handleOnClickAccountId(row?.account?._id, row?.contact?._id)}>{`# ${row?.account?.account_id}`}</Account>}
              </AccountWrapper>
              }
            </TableCell>
            <TableCell
              className="charged-value"
              align="left"
              onClick={() => {
                setDrawerData(row);
                setOpenDrawer(true);
              }}
            >
              <div className="participant__name">
                <div className="participant__name-text">
                  {row?.firstName}
                </div>
                {/* {row?.addedBy && (
                  <div className="participant__name-tag">{row?.addedBy}</div>
                )} */}
              </div>
            </TableCell>
            <TableCell
              className="charged-value"
              align="left"
              onClick={() => {
                setDrawerData(row);
                setOpenDrawer(true);
              }}
            >
              {row?.lastName}
            </TableCell>
            <TableCell
              className="charged-value"
              align="left"
              onClick={() => {
                setDrawerData(row);
                setOpenDrawer(true);
              }}
            >
              {row?.dateOfBirth ? formatDate({date:row?.dateOfBirth, formatType:"defaultWithUTC"}) : ""}
            </TableCell>
            <TableCell
              className="charged-value"
              align="left"
              onClick={() => {
                setDrawerData(row);
                setOpenDrawer(true);
              }}
            >
              {row?.class?.class_details?.grade}
            </TableCell>
            <TableCell
              className="charged-value"
              align="left"
              onClick={() => {
                setDrawerData(row);
                setOpenDrawer(true);
              }}
            >
              {!row?.member && (<CheckCircleIcon
                color="primary"
                className="ml-8"
              />)}
            </TableCell>

            <TableCell className="registration__status" align="left">
              <SElect
                options={row?.registrationStatus === "deleted" ? options : options.filter((item) => item.value !== "pending")}
                menuPortalTarget={document.body}
                menuPlacement="auto"
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
                onChange={(value) => {
                  setSelectedStatus({
                    label: value?.label,
                    value: value?.value,
                    id: row?._id,
                  });
                  setCurrentRow(row);
                  setConfirmDialog(true);
                }}
                value={{
                  label:
                    row?.registrationStatus === 'approved' ? (
                      <span className="Approved">
                        <Paidicon className="mr-1" /> Approved
                      </span>
                    ) : row?.registrationStatus === 'not-approve' ? (
                      <span className="not__approved">Not Approved</span>
                    ) : row?.registrationStatus === 'on-hold' ? (
                      <span className="on__hold"> On Hold</span>
                    ) : row?.registrationStatus === 'pending' ? (
                      <span className="pending">Pending</span>
                    ) : (
                      <span className="Approved">
                        {row?.registrationStatus}
                      </span>
                    ),
                  value: row?.registrationStatus,
                }}
              />
            </TableCell>
            <TableCell className="payment__status" align="left">
              <Status type={row?.payment?.approve?.status}>
                <img
                  src={
                    row?.payment?.approve?.status === 'paid'
                      ? PaidIcon
                      : PendingIcon
                  }
                  alt="paid-icon"
                ></img>{' '}
                {row?.payment?.approve?.status || 'pending'}
              </Status>
            </TableCell>

            <TableCell
              className="charged-value"
              align="center"
              onClick={() => {
                setDrawerData(row);
                setOpenDrawer(true);
              }}
            >

              {totalPaymentCalculation(row?.payment?.approve?.totalPaid,row?.payment?.register?.totalPaid)}
            </TableCell>
            <TableCell className="sticky-body-column">
              <div
                style={{
                  cursor: 'pointer',
                  paddingleft: '0px',
                }}
              >
                <Action
                  action="participant"
                  style={{ width: '16px' }}
                  onEditViewClick={() => {
                    setDrawerData(row);
                    setOpenDrawer(true);
                  }}
                  onParticipantDeleteClick={() => {
                    setCurrentRow(row);
                    setDeleteId(row._id);
                    setConfirmDialog(true);
                  }}
                  onMoveToClick={() => {
                    setMoveParticipantId(row._id);
                  }}
                  setClassMovedId={setClassMovedId}
                  setConfirmDialog={setConfirmDialog}
                />
              </div>
            </TableCell>
          </TableRow>
        ))
      )}
      <AlertDialog
        open={confirmDialog}
        onDecline={() => {
          setDeleteId(null);
          setPaymentLinkId(null);
          setSelectedStatus(null);
          setCurrentRow(null);
          setConfirmDialog(false);
        }}
        onAccept={() => {
          if (deleteId) {
            deleteParticipant(deleteId);
          }
          if (selectedStatus?.id) {
            changeStatus(selectedStatus);
          }
          if (paymentLinkId) {
            sendPaymentLink(paymentLinkId);
          }
          if (moveParticipantId && classMovedId) {
            moveParticipantToAnotherClass();
          }
        }}
        title="Are you sure?"
        description={selectedStatus?.id ? getStatusMessage(selectedStatus?.value, currentRow) : deleteId ? getDeleteMessage(currentRow) : ''}

        disabled={confirmLoading}
      />
    </>
  );
};

export default ParticipantDetailsTableBody;
